import { ActionType, CardSettingError } from '@banking/ui/workflows/card-settings';
import { filter, map } from 'rxjs/operators';
import { EventLogging } from './analytics';
import { isReplacementCard } from '@banking/ui/utils/card-settings-utils';
import { getCardStatusPill } from '@banking/ui/utils/card-status-pill-utils';
export let SubFeature = /*#__PURE__*/function (SubFeature) {
  SubFeature["RevealCardDetails"] = "Reveal Card Details";
  return SubFeature;
}({});
export let Target = /*#__PURE__*/function (Target) {
  Target["ActivatePhysicalCard"] = "Activate Physical Card";
  Target["AtmLimits"] = "ATM Limits";
  Target["ManageNotifications"] = "Manage Notifications";
  Target["ViewReplacementCard"] = "View Replacement Card";
  return Target;
}({});

// ============================================================================//
// Create a RxJS operator function which transforms our workflow's update
// stream to a stream of the event you're attempting to track.
//
// Afterward, "install it" via the use of the analytics function in the default
// export which merges all signals into a single stream for use with the CDP
// Ember Service.
// ============================================================================

const activateCardClick = updates => updates.pipe(filter(([_, action]) => action.type === ActionType.UserClickActivateCard), map(([[before, _after], _]) => EventLogging.CDP.event({
  action: EventLogging.Action.Click,
  target: Target.ActivatePhysicalCard,
  unitToken: before.unitToken,
  isReplacementCard: before.card != null && isReplacementCard(before.card)
})));
const atmLimitsClick = updates => updates.pipe(filter(([_, action]) => action.type === ActionType.UserClickAtmLimits), map(([[before, _after], _]) => EventLogging.CDP.event({
  action: EventLogging.Action.Click,
  target: Target.AtmLimits,
  unitToken: before.unitToken
})));
const notificationsPreferencesClick = updates => updates.pipe(filter(([_, action]) => action.type === ActionType.UserClickNotificationsPreferences), map(([[before, _after], _]) => EventLogging.CDP.event({
  action: EventLogging.Action.Click,
  target: Target.ManageNotifications,
  unitToken: before.unitToken
})));
const viewCardPan = updates => updates.pipe(filter(([[before, after]]) => !before.showCardDetails && after.showCardDetails), map(([[before, _after], _]) => EventLogging.CDP.event({
  action: EventLogging.Action.View,
  isRevealed: true,
  subFeature: SubFeature.RevealCardDetails,
  unitToken: before.unitToken
})));
const debitCardSettingsView = updates => updates.pipe(filter(([[_before, after], action]) => action.type === ActionType.GetCardCustomizationReceived && after.loading === false && after.error !== CardSettingError.Generic), map(([[_before, after], _]) => EventLogging.CDP.event({
  action: EventLogging.Action.View,
  cardStatus: after.card ? getCardStatusPill(after.card)?.trackingText : undefined,
  isReplacementCard: Boolean(after.card != null && isReplacementCard(after.card)),
  unitToken: after.unitToken
})));
const viewReplacementCardClick = updates => updates.pipe(filter(([_, action]) => action.type === ActionType.UserClickViewReplacementCard), map(([[before, _after], _]) => EventLogging.CDP.event({
  action: EventLogging.Action.Click,
  target: Target.ViewReplacementCard,
  unitToken: before.unitToken
})));
export default [activateCardClick, atmLimitsClick, debitCardSettingsView, notificationsPreferencesClick, viewCardPan, viewReplacementCardClick];